import { t } from "../../i18n";
import { Dialog } from "../../ui/Dialog";
import { QrCode } from "../../ui/QrCode";
import "./table-cards.css";

/** A card to print, as the server gives it: the table, its room and the link in its QR code. */
export interface TableCard {
  room: string;
  table: string;
  url: string;
}

interface Props {
  shop: string;
  cards: readonly TableCard[];
  onClose: () => void;
}

/**
 * "🖨 QR-kaartjes" (QR-bestellen aan tafel): a card per table, four on an A4 (A6 each, to cut and put in a stand),
 * printed from the browser. Each card has the shop, the table in big letters, its QR code and what to do. Beheer ›
 * Tafelplan on the till and Tafo-beheer › zaak › Instellingen show the same cards.
 */
export function TableCardsDialog({ shop, cards, onClose }: Props) {
  const text = t.tableCards;
  return (
    <Dialog
      title={text.title(cards.length)}
      size="wide"
      onClose={onClose}
      footer={
        <>
          <span className="spacer" />
          <button type="button" className="btn" onClick={onClose}>
            {text.close}
          </button>
          <button type="button" className="btn primary" data-autofocus onClick={() => window.print()}>
            🖨 {text.print}
          </button>
        </>
      }
    >
      <p className="note">{text.note}</p>
      <div className="qrcards">
        {cards.map((card) => (
          <article key={card.url} className="qrcard" aria-label={text.table(card.table)}>
            <span className="qrcard-shop">{shop}</span>
            <b className="qrcard-table">{text.table(card.table)}</b>
            <span className="qrcard-room">{card.room}</span>
            <div className="qrcard-qr">
              <QrCode text={card.url} label={text.table(card.table)} />
            </div>
            <span className="qrcard-do">{text.steps}</span>
            <span className="qrcard-pay">{text.pay}</span>
          </article>
        ))}
      </div>
    </Dialog>
  );
}
